import { Service, signal } from '@angular/core';
import type { PanelListData } from '../models/panel-response.model';

/**
 * Response TERAKHIR tiap endpoint panel, per vendor — ditulis `ProfilePanelService.getPanel()`,
 * dibaca checklist section (`<app-section-checklist>`).
 *
 * Kenapa ada: checklist butuh data panel yang SAMA dengan yang baru saja dimuat section di
 * bawahnya, dan harus ikut segar setiap kali section me-`load()` ulang sesudah tambah / ubah /
 * hapus. Request kedua dari checklist berarti `<endpoint>` dobel di tiap kunjungan dan tetap tidak
 * tahu kapan harus memuat ulang; meminta 7 section menyetor datanya berarti 7 tempat yang bisa
 * lupa. `getPanel()` adalah satu-satunya pintu semua pemuatan itu, jadi salinannya diambil di sana.
 *
 * Yang disimpan response MENTAH (`items` + `revision_items`), bukan hasil olahan: pembaca yang
 * memilih antara `pairEntries()` dan `resolveEntities()`.
 *
 * Singleton root karena penulisnya (`ProfilePanelService`) singleton root. Supaya tidak basi lintas
 * kunjungan, pembacanya mengosongkan store ini saat dihancurkan.
 */
@Service()
export class PanelSnapshotStore {
  private readonly snapshots = signal<ReadonlyMap<string, PanelListData | null>>(new Map());

  /** `undefined` = endpoint ini belum pernah dimuat; `null` = dimuat tapi BE mengirim `data: null`. */
  get(endpoint: string, vendorId: string): PanelListData | null | undefined {
    return this.snapshots().get(key(endpoint, vendorId));
  }

  set(endpoint: string, vendorId: string, data: PanelListData | null): void {
    this.snapshots.update((map) => new Map(map).set(key(endpoint, vendorId), data));
  }

  clear(): void {
    this.snapshots.set(new Map());
  }
}

const key = (endpoint: string, vendorId: string): string => `${vendorId}|${endpoint}`;
